// extracted by mini-css-extract-plugin
export default {"button":"TextWithCopyControl_button__zKKy6"};